export enum QUERY_KEYS {
  POLICY = 'policy',
  MOBILE_PHONE = 'mobileNo',
  QID = 'qatarid',
  MAKE = 'makeCode',
  MODEL = 'modelCode',
  PROD_CODE = 'prodCode'
}

export enum DEFAULT_CONTACTS {
  PHONE = '8 800 742',
  MOBILE_PHONE = '+9718800742',
  EMAIL_MANDATORY = 'mandatory@qic.com.qa',
  WHATS_APP_LINK = 'https://api.whatsapp.com/send/?phone=97180074248&text&app_absent=0',
  WHATS_APP_LINK_CARE =
  'https://api.whatsapp.com/send/?phone=97450000742&text&app_absent=0',
  WHATS_APP_LINK_CALLBACK =
  'https://api.whatsapp.com/send/?phone=971569989505&text&app_absent=0',
}

export const WORDINGS = [
  {
    categoryID: 1,
    category: 'General Inquiries',
    docFullName: 'QIC_Data_Privacy_Notice',
    Link: '/pdf/QIC_Data_Privacy_Notice.pdf',
    SortOrder: 1,
    coverCode: '',
    docShortName: 'privpolicy',
    productCode: null,
  }, {
    categoryID: 9,
    category: 'Car Comprehensive',
    docFullName: 'Motor_Terms_And_Conditions',
    Link: '/pdf/Motor_Terms_And_Conditions.pdf',
    SortOrder: 2,
    coverCode: '',
    docShortName: 'carodtc',
    productCode: ['0110'],
  }, {
    categoryID: 16,
    category: 'Car Comprehensive Installments',
    docFullName: 'Motor_Terms_And_Conditions_Installment',
    Link: '/pdf/Motor_Terms_And_Conditions_Installment.pdf',
    SortOrder: 3,
    coverCode: '',
    docShortName: 'carinstalltc',
    productCode: ['0110'],
  }, {
    categoryID: 17,
    category: 'Visitors',
    docFullName: 'terms-and-conditions',
    Link: '/pdf/visitors/terms-and-conditions.pdf',
    SortOrder: 4,
    coverCode: '',
    docShortName: 'visitorscheckout',
    productCode: null,
  }, {
    categoryID: 17,
    category: 'Visitors',
    docFullName: 'visitors-tob',
    Link: '/pdf/visitors/visitors-tob.pdf',
    SortOrder: 5,
    coverCode: '',
    docShortName: 'visitorstob',
    productCode: null,
  }, {
    categoryID: 17,
    category: 'Visitors',
    docFullName: 'policy-wording',
    Link: '/pdf/visitors/policy-wording.pdf',
    SortOrder: 6,
    coverCode: '',
    docShortName: 'visitorstc',
    productCode: null,
  }, {
    categoryID: 7,
    category: 'Travel',
    docFullName: 'Travel_Terms_And_Conditions_Outbound',
    Link: '/pdf/Travel_Terms_And_Conditions_Outbound.pdf',
    SortOrder: 7,
    coverCode: '',
    docShortName: 'travelouttc',
    productCode: ['0180'],
  }, {
    categoryID: 7,
    category: 'Travel',
    docFullName: 'Travel_Terms_And_Conditions_Inbound',
    Link: '/pdf/Travel_Terms_And_Conditions_Inbound.pdf',
    SortOrder: 8,
    coverCode: '',
    docShortName: 'tavelinbtc',
    productCode: ['0181'],
  }, {
    categoryID: 5,
    category: 'Home',
    docFullName: 'Home_Terms_And_Conditions',
    Link: '/pdf/Home_Terms_And_Conditions.pdf',
    SortOrder: 9,
    coverCode: '',
    docShortName: 'hometc',
    productCode: ['0140'],
  }, {
    categoryID: 6,
    category: 'Personal Accident',
    docFullName: 'Personal_Accident_Benefit',
    Link: '/pdf/Personal_Accident_Benefit.pdf',
    SortOrder: 10,
    coverCode: '',
    docShortName: 'pabtc',
    productCode: null,
  }, {
    categoryID: 10,
    category: 'Car TPL',
    docFullName: 'Third_Party_Liability',
    Link: '/pdf/Third_Party_Liability.pdf',
    SortOrder: 11,
    coverCode: '',
    docShortName: 'cartpltc',
    productCode: ['0100'],
  }, {
    categoryID: 4,
    category: 'Boat & Yacht',
    docFullName: 'PleasureTP_Wordings',
    Link: '/pdf/PleasureTP_Wordings.pdf',
    SortOrder: 12,
    coverCode: '',
    docShortName: 'boattpltc',
    productCode: ['0612'],
  }, {
    categoryID: 4,
    category: 'Boat & Yacht',
    docFullName: 'PleasureOwn_Wordings',
    Link: '/pdf/PleasureOwn_Wordings.pdf',
    SortOrder: 13,
    coverCode: '',
    docShortName: 'boadodtc',
    productCode: ['0604'],
  }, {
    categoryID: 5,
    category: 'Home',
    docFullName: 'Home_Assistance',
    Link: '/pdf/Home_Assistance.pdf',
    SortOrder: 14,
    coverCode: '',
    docShortName: 'homeassist',
    productCode: null,
  }, {
    categoryID: 16,
    category: 'Car Comprehensive Installments',
    docFullName: 'Installment_Terms_Conditions',
    Link: '/pdf/Installment_Terms_Conditions.pdf',
    SortOrder: 15,
    coverCode: '',
    docShortName: 'install',
    productCode: ['0110'],
  }, {
    categoryID: 1,
    category: 'General Inquiries',
    docFullName: 'Motor_Social_Responsibility',
    Link: '/pdf/Motor_Social_Responsibility.pdf',
    SortOrder: 16,
    coverCode: '',
    docShortName: 'motor',
    productCode: null,
  }, {
    categoryID: 1,
    category: 'General Inquiries',
    docFullName: 'HomecareProposalForm',
    Link: '/pdf/HomecareProposalForm.pdf',
    SortOrder: 17,
    coverCode: '',
    docShortName: '\u0440omeproposalform',
    productCode: null,
  }, {
    categoryID: 18,
    category: 'Golf',
    docFullName: 'Golf_Insurance_Terms_And_Conditions',
    Link: '/pdf/Golf_Insurance_Terms_And_Conditions.pdf',
    SortOrder: 18,
    coverCode: '',
    docShortName: 'golf',
    productCode: null,
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'car_agencyrepair',
    Link: '/pdf/car_agencyrepair.pdf',
    SortOrder: 19,
    coverCode: '01008',
    docShortName: 'agencyrepair',
    productCode: ['0110', '0100'],
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'car_elite_roadside',
    Link: '/pdf/car_elite_roadside.pdf',
    SortOrder: 20,
    coverCode: '01036',
    docShortName: 'rsa',
    productCode: ['0110', '0100'],
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'car_emergency_roadside',
    Link: '/pdf/car_emergency_roadside.pdf',
    SortOrder: 21,
    coverCode: '01036',
    docShortName: 'emergrsa',
    productCode: ['0110', '0100'],
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'car_gap_cover',
    Link: '/pdf/car_gap_cover.pdf',
    SortOrder: 22,
    coverCode: '01022',
    docShortName: 'gap',
    productCode: ['0110', '0100'],
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'car_gcc',
    Link: '/pdf/car_gcc.pdf',
    SortOrder: 23,
    coverCode: '01045',
    docShortName: 'gcc',
    productCode: ['0110', '0100'],
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'car_no_deprication',
    Link: '/pdf/car_no_deprication.pdf',
    SortOrder: 24,
    coverCode: '01029',
    docShortName: 'nodeprication',
    productCode: ['0110', '0100'],
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'car_off_road',
    Link: '/pdf/car_off_road.pdf',
    SortOrder: 25,
    coverCode: '01012',
    docShortName: 'offroad',
    productCode: ['0110', '0100'],
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'car_off_road_360',
    Link: '/pdf/car_off_road_360.pdf',
    SortOrder: 26,
    coverCode: '01033',
    docShortName: 'offroad360',
    productCode: ['0110', '0100'],
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'car_policy_accident',
    Link: '/pdf/car_policy_accident.pdf',
    SortOrder: 27,
    coverCode: '01205',
    docShortName: 'pa',
    productCode: ['0110', '0100'],
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'car_replacement',
    Link: '/pdf/car_replacement.pdf',
    SortOrder: 28,
    coverCode: '01049',
    docShortName: 'replacement',
    productCode: ['0110', '0100'],
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'car_riot',
    Link: '/pdf/car_riot.pdf',
    SortOrder: 29,
    coverCode: '01026',
    docShortName: 'riot',
    productCode: ['0110', '0100'],
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'car_unknowm_damage',
    Link: '/pdf/car_unknowm_damage.pdf',
    SortOrder: 30,
    coverCode: '01052',
    docShortName: 'undamage',
    productCode: ['0110', '0100'],
  }, {
    categoryID: 7,
    category: 'Travel',
    docFullName: 'travel_winter',
    Link: '/pdf/travel_winter.pdf',
    SortOrder: 31,
    coverCode: '08050',
    docShortName: 'winter',
    productCode: ['0180', '0181'],
  }, {
    categoryID: 7,
    category: 'Travel',
    docFullName: 'travel_covid19',
    Link: '/pdf/travel_covid19.pdf',
    SortOrder: 32,
    coverCode: '08054',
    docShortName: 'civid19',
    productCode: ['0180', '0181'],
  }, {
    categoryID: 5,
    category: 'Home',
    docFullName: 'home_insurance',
    Link: '/pdf/home_insurance.pdf',
    SortOrder: 33,
    coverCode: '',
    docShortName: 'home',
    productCode: null,
  }, {
    categoryID: 6,
    category: 'Personal Accident',
    docFullName: 'pab_insurance',
    Link: '/pdf/pab_insurance.pdf',
    SortOrder: 34,
    coverCode: '',
    docShortName: 'pab',
    productCode: ['0823'],
  }, {
    categoryID: 8,
    category: 'Claim',
    docFullName: 'PAB_Claim_form',
    Link: '/pdf/PAB_Claim_form.pdf',
    SortOrder: 35,
    coverCode: '',
    docShortName: 'pabclaim',
    productCode: null,
  }, {
    categoryID: 8,
    category: 'Claim',
    docFullName: 'Travel_Claim_form',
    Link: '/pdf/Travel_Claim_form.pdf',
    SortOrder: 36,
    coverCode: '',
    docShortName: 'travelclaim',
    productCode: null,
  }, {
    categoryID: 8,
    category: 'Claim',
    docFullName: 'Home_Claim_form',
    Link: '/pdf/Home_Claim_form.pdf',
    SortOrder: 37,
    coverCode: '',
    docShortName: 'homeclaim',
    productCode: null,
  }, {
    categoryID: 19,
    category: 'Promo Campaign',
    docFullName: '123_tc',
    Link: '/pdf/123_tc.pdf',
    SortOrder: 38,
    coverCode: '',
    docShortName: '123promo',
    productCode: null,
  }, {
    categoryID: 19,
    category: 'Promo Campaign',
    docFullName: 'Article_Drive_safely_AR',
    Link: '/pdf/Article_Drive_safely_AR.pdf',
    SortOrder: 39,
    coverCode: '',
    docShortName: 'artsafear',
    productCode: null,
  }, {
    categoryID: 19,
    category: 'Promo Campaign',
    docFullName: 'Article_Drive_safely_ENG',
    Link: '/pdf/Article_Drive_safely_ENG.pdf',
    SortOrder: 40,
    coverCode: '',
    docShortName: 'artsafeeng',
    productCode: null,
  }, {
    categoryID: 19,
    category: 'Promo Campaign',
    docFullName: 'Article_traffic_AR',
    Link: '/pdf/Article_traffic_AR.pdf',
    SortOrder: 41,
    coverCode: '',
    docShortName: 'arttrafficar',
    productCode: null,
  }, {
    categoryID: 19,
    category: 'Promo Campaign',
    docFullName: 'Article_traffic_ENG',
    Link: '/pdf/Article_traffic_ENG.pdf',
    SortOrder: 42,
    coverCode: '',
    docShortName: 'arttrafficeng',
    productCode: null,
  }, {
    categoryID: 19,
    category: 'Promo Campaign',
    docFullName: 'Checklist_Driving_AR',
    Link: '/pdf/Checklist_Driving_AR.pdf',
    SortOrder: 43,
    coverCode: '',
    docShortName: 'checkdrivear',
    productCode: null,
  }, {
    categoryID: 19,
    category: 'Promo Campaign',
    docFullName: 'Checklist_Driving_ENG',
    Link: '/pdf/Checklist_Driving_ENG.pdf',
    SortOrder: 44,
    coverCode: '',
    docShortName: 'checkdriveeng',
    productCode: null,
  }, {
    categoryID: 19,
    category: 'Promo Campaign',
    docFullName: 'Checklist_Parking_AR',
    Link: '/pdf/Checklist_Parking_AR.pdf',
    SortOrder: 45,
    coverCode: '',
    docShortName: 'checkparkar',
    productCode: null,
  }, {
    categoryID: 19,
    category: 'Promo Campaign',
    docFullName: 'Checklist_Parking_ENG',
    Link: '/pdf/Checklist_Parking_ENG.pdf',
    SortOrder: 46,
    coverCode: '',
    docShortName: 'checkparkeng',
    productCode: null,
  }, {
    categoryID: 1,
    category: 'General Inquiries',
    docFullName: 'Home_all_risks_insurance_policy',
    Link: '/pdf/Home_all_risks_insurance_policy.pdf',
    SortOrder: 47,
    coverCode: '',
    docShortName: 'homeall',
    productCode: null,
  }, {
    categoryID: 2,
    category: 'Car',
    docFullName: 'Replacement_Hire_Car',
    Link: '/pdf/Replacement_Hire_Car.pdf',
    SortOrder: 48,
    coverCode: '',
    docShortName: 'rhc',
    productCode: null,
  }, {
    categoryID: 20,
    category: 'Articles',
    docFullName: 'Article_Car',
    Link: '/pdf/articles/Article_Car.pdf',
    SortOrder: 49,
    coverCode: '',
    docShortName: 'artcareng',
    productCode: null,
  }, {
    categoryID: 20,
    category: 'Articles',
    docFullName: 'Article_Car_AR',
    Link: '/pdf/articles/Article_Car_AR.pdf',
    SortOrder: 50,
    coverCode: '',
    docShortName: 'artcarar',
    productCode: null,
  }, {
    categoryID: 20,
    category: 'Articles',
    docFullName: 'Article_Insurance_company',
    Link: '/pdf/articles/Article_Insurance_company.pdf',
    SortOrder: 51,
    coverCode: '',
    docShortName: 'artinseng',
    productCode: null,
  }, {
    categoryID: 20,
    category: 'Articles',
    docFullName: 'Article_Insurance_company_AR',
    Link: '/pdf/articles/Article_Insurance_company_AR.pdf',
    SortOrder: 52,
    coverCode: '',
    docShortName: 'artinsar',
    productCode: null,
  }, {
    categoryID: 20,
    category: 'Articles',
    docFullName: 'Checklist_Car_AR',
    Link: '/pdf/articles/Checklist_Car_AR.pdf',
    SortOrder: 53,
    coverCode: '',
    docShortName: 'checkcarar',
    productCode: null,
  }, {
    categoryID: 20,
    category: 'Articles',
    docFullName: 'Checklist_Car_ENG',
    Link: '/pdf/articles/Checklist_Car_ENG.pdf',
    SortOrder: 54,
    coverCode: '',
    docShortName: 'checkcareng',
    productCode: null,
  }, {
    categoryID: 20,
    category: 'Articles',
    docFullName: 'Checklist_Travel_AR',
    Link: '/pdf/articles/Checklist_Travel_AR.pdf',
    SortOrder: 55,
    coverCode: '',
    docShortName: 'checktravelar',
    productCode: null,
  }, {
    categoryID: 20,
    category: 'Articles',
    docFullName: 'Checklist_Travel_ENG',
    Link: '/pdf/articles/Checklist_Travel_ENG.pdf',
    SortOrder: 56,
    coverCode: '',
    docShortName: 'checktraveleng',
    productCode: null,
  }, {
    categoryID: 21,
    category: 'QLM',
    docFullName: 'MVHI-Policy-Wording',
    Link: '/pdf/qlm/MVHI-Policy-Wording.pdf',
    SortOrder: 57,
    coverCode: '',
    docShortName: 'qlmwording',
    productCode: null,
  }, {
    categoryID: 21,
    category: 'QLM',
    docFullName: 'terms-and-conditions-qlm',
    Link: '/pdf/qlm/terms-and-conditions-qlm.pdf',
    SortOrder: 58,
    coverCode: '',
    docShortName: 'qlmtc',
    productCode: null,
  }, {
    categoryID: 21,
    category: 'QLM',
    docFullName: 'visitors-tob-qlm',
    Link: '/pdf/qlm/visitors-tob-qlm.pdf',
    SortOrder: 59,
    coverCode: '',
    docShortName: 'qlmtob',
    productCode: null,
  }, {
    categoryID: 17,
    category: 'Visitors',
    docFullName: 'Healthcare-providers-in-Qatar',
    Link: '/pdf/visitors/Healthcare-providers-in-Qatar.pdf',
    SortOrder: 60,
    coverCode: '',
    docShortName: 'healthcare',
    productCode: null,
  }, {
    categoryID: 19,
    category: 'Promo Campaign',
    docFullName: '3_month_Terms_Conditions.pdf',
    Link: 'pdf/3_month_Terms_Conditions.pdf',
    SortOrder: 61,
    coverCode: '',
    docShortName: 'tc3mff',
    productCode: null,
  },
];